import axios from '@/plugins/axios'

const sendContactForm = async ({ name = '', subject = '', message = '', email = '', website = '' }) => {
  const params = {
    name: name,
    subject: subject,
    message: message,
    email: email
  }
  if (website) params.website = website
  try {
    const response = await axios.post('static/contact', params)
    const data = { response }
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const storeLead = async ({ name = '', email = '', source = '' }) => {
  const params = {
    name: name,
    source: source,
    email: email
  }
  try {
    const response = await axios.post('lead', params)
    const data = { response }
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getAboutNumbers = async () => {
  try {
    const response = await axios.get('static/about')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getAboutNumbers,
  sendContactForm,
  storeLead
}
